import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import "./PrecisionSection.css";

const PrecisionSection = () => (
  <section id="precision">
    <div className="wrap">
      <div className="split">
        <div className="precision-text">
          <span className="eyebrow-pill">
            <SatelliteAltIcon style={{ fontSize: 14, verticalAlign: "-2px", marginRight: 6 }} />
            Une précision uniforme
          </span>
          <h2 className="precision-h2">
            Pourquoi notre météo des feux change la donne ?{" "}
          </h2>
          <p className="precision-body">
            Les modèles météorologiques traditionnels s'appuient largement
            sur des stations de mesure au sol. Utiles, mais inégalement
            réparties : denses en zone urbaine, beaucoup plus éparses dès
            que l'on s'éloigne des grands axes, précisément là où se
            déclenchent la majorité des feux de forêt.
          </p>
          <p className="precision-body">
            Notre approche est différente. En mobilisant des constellations
            de satellites de nouvelle génération, ensemblepourlaforêt.fr
            offre une précision homogène sur tout le territoire, à
            l'échelle de <strong>3 km</strong> qu'il s'agisse d'un
            massif forestier isolé, d'un maquis corse ou d'une vallée
            alpine. Aucune zone blanche, aucun angle mort : une vigilance
            qui ne dépend plus de la densité des stations au sol, mais qui
            couvre uniformément chaque kilomètre carré du pays.
          </p>
          <div className="precision-stats">
            <div className="precision-stat">
              <div className="precision-stat-n">3 km</div>
              <div className="precision-stat-l">Précision homogène</div>
            </div>
            <div className="precision-stat">
              <div className="precision-stat-n">100%</div>
              <div className="precision-stat-l">Du territoire couvert</div>
            </div>
            <div className="precision-stat">
              <div className="precision-stat-n">0</div>
              <div className="precision-stat-l">Zone blanche</div>
            </div>
          </div>
          <p className="precision-note">
            ensemblepourlaforêt.fr n'informe pas sur les feux en cours.
            <br />
            Pour connaître les restrictions d'accès ou de circulation,
            consultez le site de votre préfecture.
          </p>
        </div>
        <div className="precision-visual">
          <img
            className="section-illustration"
            src="/images/stlvf.png"
            alt="Précision satellite de 3 km sur tout le territoire"
          />
        </div>
      </div>
    </div>
  </section>
);

export default PrecisionSection;